const getRGBAValues = require('../getRGBAValues');

const alphaHexRegExp = new RegExp(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
const hexRegExp = new RegExp(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
const sortHexRegExp = new RegExp(/^#?([a-f\d])([a-f\d])([a-f\d])$/i);

const formatHexNumber = (item) => parseInt(
    item.repeat(3 - item.length),
    16
);

const formatHexOpacity = (opacity) => Number(
    (parseInt(opacity, 16) / 255).toFixed(2)
);

/**
 * Converts a color string into rgba object
 * @param {String} color- Hex / Rgb / Rgba color string
 * @param {Number} opacity - The opacity to use
 * @returns {Object}
 */
const convertColorToRgba = (color, opacity = 1) => {
    const hexResult = hexRegExp.exec(color) || alphaHexRegExp.exec(color) || sortHexRegExp.exec(color);
    if (!hexResult) {
        return getRGBAValues(color);
    }

    const hexOpacity = hexResult[4] !== undefined ? formatHexOpacity(hexResult[4]) : opacity;

    return {
        r: formatHexNumber(hexResult[1]),
        g: formatHexNumber(hexResult[2]),
        b: formatHexNumber(hexResult[3]),
        a: hexOpacity
    };
};

module.exports = convertColorToRgba;
